export default "__VITE_ASSET__61921953__"